import { assoc, chain } from 'icepick';
import get from 'lodash/get';
import {
	SUBMIT_INITIATED_STATUS,
	SUBMIT_COMPLETED_STATUS,
} from '@atlassian/jira-servicedesk-common/src/ui/components/submit-button/model.tsx';
import type { SummaryPage, SummaryRunAsUserSettings } from '../../../model';
import { RETRIEVE_SUCCESS, type SummaryLoadSuccessAction } from '../../actions/retrieve';
import {
	SAVE_RUN_AS_USER,
	type SaveRunAsUserAction,
	SAVE_RUN_AS_USER_FAILURE,
	type SaveRunAsUserFailureAction,
	SAVE_RUN_AS_USER_SUCCESS,
	type SaveRunAsUserSuccessAction,
	SET_SHOW_DIALOG,
	type SetShowDialogAction,
	SET_SHOW_MISCONFIGURED_DIALOG,
	type SetShowMisconfiguredDialogAction,
} from '../../actions/run-as-user';
import type { RunAsUserUIState } from './types';

export const DEFAULT_RUN_AS_USER_UI_STATE: RunAsUserUIState = {
	showDialog: false,
	showMisconfiguredDialog: false,
	saveError: null,
	submitStatus: null,
};

type Actions =
	| SetShowDialogAction
	| SaveRunAsUserAction
	| SaveRunAsUserSuccessAction
	| SaveRunAsUserFailureAction
	| SetShowMisconfiguredDialogAction
	| SummaryLoadSuccessAction;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	state: RunAsUserUIState = DEFAULT_RUN_AS_USER_UI_STATE,
	action: Actions,
): RunAsUserUIState => {
	switch (action.type) {
		case RETRIEVE_SUCCESS: {
			const summaryPage: SummaryPage = action.payload;
			const runAsUserSettings: SummaryRunAsUserSettings =
				summaryPage.result.projectRunAsUserSettings;
			if (!get(runAsUserSettings, ['config', 'user', 'isValid'])) {
				return assoc(state, 'showMisconfiguredDialog', true);
			}
			return state;
		}
		case SET_SHOW_DIALOG: {
			const { show } = action.payload;
			// Reset state on close
			if (show === false) {
				return DEFAULT_RUN_AS_USER_UI_STATE;
			}
			return assoc(state, 'showDialog', show);
		}
		case SET_SHOW_MISCONFIGURED_DIALOG: {
			const { show } = action.payload;
			// Reset state on close
			if (show === false) {
				return DEFAULT_RUN_AS_USER_UI_STATE;
			}
			return assoc(state, 'showMisconfiguredDialog', show);
		}
		case SAVE_RUN_AS_USER:
			return chain(state)
				.assoc('saveError', null)
				.assoc('submitStatus', SUBMIT_INITIATED_STATUS)
				.value();
		case SAVE_RUN_AS_USER_SUCCESS:
			return assoc(state, 'submitStatus', SUBMIT_COMPLETED_STATUS);
		case SAVE_RUN_AS_USER_FAILURE:
			return chain(state)
				.assoc('saveError', action.payload.errorMessage)
				.assoc('submitStatus', null)
				.value();
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
